$(document).ready(function () {
    const selectedCurrency = localStorage.getItem('currency')  || 'AED';

  $('.bundly__bundle_new_price').each(function () {
    let $this = $(this);

    // Get the original text (e.g., "1,458.20 AED")
    let originalText = $this.text().trim();

    // Extract the number and currency using regex
    let match = originalText.match(/^([\d,]+\.\d+)\s*(\w+)$/);
    if (match) {
      let formattedNumber = match[1]; // "1,458.20"
      let currency = match[2]; // "AED"
      let baseValue = formattedNumber.replace(/,/g, ''); // "1458.20"

      // Update the element
      $this
        .addClass('money')
        .attr('data-base', baseValue)
        .html(`${formattedNumber} ${currency}`);
    }
  });
  
  const adoricElement = document.querySelector('adoric-bundle-mark-six');
  if (adoricElement && adoricElement.shadowRoot) {
    const target = adoricElement.shadowRoot.querySelectorAll('nav.svelte-14ne37t');
    target.forEach(priceEl => {
      let originalText = priceEl.textContent.trim();

      const match = originalText.match(/^(\w+)[\s\u00A0]+([\d,]+\.\d{2})$/);
      if (match) {
        let formattedNumber = match[2]; // "1,458.20"
        let currency = match[1];        // "AED"
        let baseValue = formattedNumber.replace(/,/g, ''); // "1458.20"

        priceEl.classList.add('money');
        priceEl.setAttribute('data-base', baseValue);
        priceEl.innerHTML = `${formattedNumber} ${currency}`;
      }
    });

    if (document.documentElement.getAttribute('dir') === 'rtl') {
      const deal_wrappers = adoricElement.shadowRoot.querySelectorAll('.deal-wrapper.svelte-1uwp20h'); 
      deal_wrappers.forEach(function (el) {
            el.style.direction = 'rtl';
        });
    }
  }
  if (window.updatePrices) {
      window.updatePrices(selectedCurrency); // or 'BHD', etc.
  }


  // $('.svelte-14ne37t').each(function () {
  // console.log('svelte-14ne37t')
  // });






  // append from text to bundle price
  var $variesPrice = $('.bundly__bundle_price_varies');

  if ($variesPrice.length && $.trim($variesPrice.html()) !== '') {
    var variesText = $variesPrice.text().trim();

    $('.price-item').each(function () {
      var currentHtml = $(this).html(); // get existing HTML
      $(this).html('<span class="varies-note" style="font-size: 60%;">' + variesText + '</span> ' + currentHtml);
    });
  }



  const video = $('.scroll-play-video')[0]; // Get the video element
  const muteUnmuteButton = $('#mute-button'); // Get the hidden button

  muteUnmuteButton.on('click', function () {
    if (video.muted) {
      video.muted = false; // Unmute the video
      muteUnmuteButton.removeClass('mute'); // Change button text to 'Mute'
    } else {
      video.muted = true; // Mute the video
      muteUnmuteButton.addClass('mute'); // Change button text to 'Unmute'
    }
  });
  $('#play-button').on('click', function () {
    if (video) {
      video.play();

      $('.video-overlay').addClass('d-none');
      $('#play-button').addClass('d-none');
    }
  });
  $('.template-collection .rich-text__blocks').each(function () {
    var $desc = $(this).find('.rich-text__text');
    var $btn = $(this).find('.rich-text__buttons');

    if ($.trim($desc.text()) === '') {
      $btn.css('display', 'none');
    }
  });

  $('.template-collection .rich-text__blocks .button').on('click', function () {
    var $desc = $('.template-collection .rich-text__blocks .rich-text__text');
    var $btn = $(this);

    $desc.toggleClass('expanded');
    var isArabic = $('html').attr('lang') === 'ar';
    if ($desc.hasClass('expanded')) {
      $btn.text(isArabic ? 'عرض أقل' : 'Read Less');
    } else {
      $btn.text(isArabic ? 'عرض المزيد' : 'Read More');
    }


  });



  var featured_collections_sectionids = ['collection-template--17553593925811__featured_collection_AwzYR8',
    'collection-template--17553593925811__featured_collection_8QzFQF',
    'collection-template--17553593925811__featured_collection_qcnYm3'];

  $('.featured-collections-list li').click(function () {

    $.each(featured_collections_sectionids, function (index, value) {
      $('#' + value).hide();
    });

    var section_id_toshow = $(this).attr('section-id');
    $('#' + section_id_toshow).show();

    $('.featured-collections-list li').removeClass('active');
    $(this).addClass('active');
  });

  $(".logo-carousel").owlCarousel({
    loop: true,
    margin: 10,
    autoplay: true,
    autoplayTimeout: 3000,
    autoplayHoverPause: true,
    dots: false, // Disable dots
    nav: false, // Disable default nav buttons
    responsive: {
      0: {
        items: 3
      },
      600: {
        items: 4
      },
      990: {
        items: 6
      }
    }
  });

  $(".owl-next").click(function () {
    $(".logo-carousel").trigger('next.owl.carousel');
  });

  $(".owl-prev").click(function () {
    $(".logo-carousel").trigger('prev.owl.carousel');
  });


  //START Brands Page Functionality//
  $(".alphabet.div-A").css('display', 'grid');
  $(".brands_parent .parent-A").addClass("active");

  $(".brands_parent div").click(function () {
    $(".brands_parent div").removeClass("active");
    $(this).addClass("active");

    var alphaClass = $(this).attr("class");
    var alpha = $(this).text();
    console.log(alpha);
    var parent = $(this).parent();
    var bigparent = parent.parent();
    $(".alphabet").css('display', 'none');
    bigparent.find(".alphabet.div-" + alpha).css('display', 'grid');
  });

  if ($('#preloader-background').length > 0) {
    setTimeout(function () {
      $('#preloader-background').hide();
    }, 2000); // 1000 milliseconds = 1 second
  }

  // jQuery("#searchx-btn").on("click", function() {
  // $(".brands_parent div").removeClass("active");
  // var value = jQuery('#searched_item').val().toLowerCase();

  // // Show all elements initially
  // jQuery(".alphabet").hide(); // Hide all elements

  // // Show elements that contain the search value
  // jQuery(".alphabet").filter(function() {
  // return jQuery(this).text().toLowerCase().includes(value);
  // }).show().css("display", "grid");
  // });
  //END Brands Page Functionality//



  $('#shopify-section-template--24299015569753__multicolumn_EPDcn4 .multicolumn-list__item').on('click', function () {
    console.log('gg');
    // Find the parent .multicolumn-card to extract the title and description
    var $card = $(this);

    // Extract the title from h3 (inside .multicolumn-card__info)
    var title = $card.find('.inline-richtext').text();

    // Extract the description from the <p> inside .rte (inside .multicolumn-card__image-wrapper)
    var description = $card.find('.rte p').text();

    // Extract the image URL (ensure we're getting the image source from the image itself, not from the clicked item)
    var imageUrl = $(this).find('img').attr('src'); // Fixed to find the <img> inside the clicked item

    // Populate the modal with this information
    $('.custom-modal .modal-image').attr('src', imageUrl);
    $('.custom-modal .p-title').text(title);
    $('.custom-modal .p-desc').text(description);

    // Set the "From the Perfumer" link URL
    var linkUrl = $card.find('.link').attr('href');
    $('.custom-modal .from-perfumer-link').attr('href', linkUrl);

    // Show the modal
    $('.custom-modal').addClass('opened-modal');
  });

  // Close the modal when the "X" button is clicked
  $('.close-custom-modal').on('click', function () {
    $('.custom-modal').removeClass('opened-modal');
  });

  // Optionally, close the modal if the user clicks outside of it
  // $(document).on('click', function(event) {
  // if (!$(event.target).closest('.custom-modal .row').length) {
  // $('.custom-modal').removeClass('opened-modal')
  // }

  // });

  $('body').on('click', '[name="checkout"], [name="goto_pp"], [name="goto_gc"]', function () {
    var checkbox;
    if ($(this).parent().attr('id') == 'cart-notification-form') {
      checkbox = $('.agree');
    } else {
      checkbox = $('#agree');
    }
    if (checkbox.is(':checked')) {
      $(this).submit();
    }
    else {
      if (document.documentElement.lang == 'ar') {
        alert("يجب أن توافق على شروط وأحكام البيع لإتمام عملية الشراء.")
        return false;
      }
      alert("You must agree with the terms and conditions of sales to check out.");
      return false;
    }
  });


});

document.addEventListener('DOMContentLoaded', function () {
  const userCountry = Shopify.country;
  console.log('Shopify', userCountry)
  if (userCountry === 'MA') {
    window.location.href = 'https://ma.taifalemarat.com';
  } else if (userCountry === 'IQ') {
    window.location.href = 'https://iq.taifalemarat.com';
  }


// force minimum quantity for customized box
   if (document.querySelector('.quantity__input[data-has-min="true"]')) {
    enforceMinQuantity();
  }

    document.addEventListener('click:ChangeVariantOption', function () {
  console.log('click:ChangeVariantOption');
 });

// document.addEventListener('cart:updated', function(){
//    setTimeout(() => {
//    if (document.querySelector('.quantity__input[data-has-min="true"]')) {
//     console.log('Running minimum qty logic after DOM settled');
//     enforceMinQuantityWithRetries();
//   }
//   }, 300);
// });
});
function enforceMinQuantity() {
  console.log('ENFORDCE MIN QTY');
  document.querySelectorAll('.quantity__input[data-has-min="true"]').forEach(input => {
    const min = input.dataset.min;
    const currentValue = parseInt(input.value, 1);
    if (min && input.getAttribute('min') !== String(min)) {      
      input.setAttribute('min', min);
      
    if (currentValue < min) {
      console.log(`Fixing value: was ${currentValue}, setting to ${min}`);
      input.value = min;
    }
       // Trigger Shopify's increment button click
      const plusButton = input.closest('.quantity').querySelector('.quantity__button[name="plus"]');
      if (plusButton) {
        plusButton.click();
      }
   }
  });
}


// function enforceMinQuantityWithRetries(retries = 5) {
//   if (retries === 0) return;

//   enforceMinQuantity();

//   // Check if value is still wrong
//   const input = document.querySelector('.quantity__input[data-has-min="true"]');

//   console.log(parseInt(input.value));
//   console.log(parseInt(input.dataset.min));
//   if (input && parseInt(input.value) < parseInt(input.dataset.min)) {
//     console.log('Value still wrong, retrying...');
//     setTimeout(() => {
//       enforceMinQuantityWithRetries(retries - 1);
//     }, 200); // Adjust delay if needed
//   } else {
//     console.log('Minimum quantity fixed.');
//   }
// }
